import React from 'react';
import { useLanguageSync } from '../i18n/useLanguageSync';

const LANGUAGES = [
  { code: 'es', label: 'ES' },
  { code: 'en', label: 'EN' },
  { code: 'pt', label: 'PT' },
];

export default function LanguageSelector() {
  const { currentLanguage, changeLanguage } = useLanguageSync();

  return (
    <div
      style={{
        display: 'inline-flex',
        gap: 0,
        borderRadius: 6,
        border: '1px solid #ddd',
        flexShrink: 0,
        overflow: 'visible',
      }}
    >
      {LANGUAGES.map(({ code, label }, idx) => (
        <button
          key={code}
          onClick={() => changeLanguage(code)}
          style={{
            padding: '4px 8px',
            fontSize: 11,
            fontWeight: currentLanguage === code ? 700 : 500,
            background: currentLanguage === code ? '#667eea' : '#fff',
            color: currentLanguage === code ? '#fff' : '#555',
            border: 'none',
            borderLeft: idx > 0 ? '1px solid #ddd' : 'none',
            cursor: 'pointer',
            transition: 'all 0.15s ease',
            minWidth: 28,
            lineHeight: 1.4,
            flexShrink: 0,
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
